module.exports = __webpack_public_path__ + "static/gallery8-7ca9d4e345e0b223c657a0ba03b31eb0.jpg";